<template>
    <div>
        <az-back-button :route="{name: 'consultaDeComprasDiretas'}" text="Voltar para listagem"></az-back-button>
        <az-container>
            <compra-direta-visualizacao-acoes></compra-direta-visualizacao-acoes>
            <div class="az-tabs">
                <v-tabs left>
                    <v-tab :to="construirRota(abas.dadosGerais.nomeRota)" v-if="true" active-class="v-tabs__item--active secondary--text">
                        {{ abas.dadosGerais.titulo }}
                    </v-tab>
                    <v-tab :to="construirRota(abas.itensLotes.nomeRota)" v-if="true" active-class="v-tabs__item--active secondary--text">
                      {{ abas.itensLotes.titulo }}
                    </v-tab>
                    <v-tab :to="construirRota(abas.documentos.nomeRota)" v-if="true" active-class="v-tabs__item--active secondary--text">
                      {{ abas.documentos.titulo }}
                    </v-tab>
                    <v-tab :to="construirRota(abas.resultado.nomeRota)" v-if="exibirResultado()" active-class="v-tabs__item--active secondary--text">
                      {{ abas.resultado.titulo }}
                    </v-tab>
                </v-tabs>
                <router-view></router-view>
            </div>
        </az-container>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { actionTypes } from '@/core/constants'
import CompraDiretaVisualizacaoAcoes from '@/views/pages/commons/detalhe-compra-direta/acoes/CompraDiretaVisualizacaoAcoes.vue'

export default {
    name: 'CompraDiretaVisualizacao',
    components: { CompraDiretaVisualizacaoAcoes },
    data() {
        return {
            abas: {
                dadosGerais: {
                    titulo: 'Dados Gerais',
                    nomeRota: 'compraDiretaVisualizacaoDadosGerais'
                },
                itensLotes: {
                    titulo: 'Itens',
                    nomeRota: 'itensLotesPublico'
                },
                documentos: {
                    titulo: 'Documentos',
                    nomeRota: 'documentosPublicos'
                },
                resultado: {
                    titulo: 'Resultado',
                    nomeRota: 'resultadoPublicos'
                },
            },
            compraDiretaId: null
        }
    },
    computed: {
        ...mapState(['compraDireta']),
    },
    async created() {
        await this.setCompraDiretaId(this.$route.params.id)
    },
    async mounted() {
        await this.buscarDadosGerais()
    },
    async beforeRouteUpdate(_to, _from, next) {
        await this.buscarDadosGerais()
        next()
    },
    methods: {
        async buscarDadosGerais() {
            await this.$store.dispatch(actionTypes.BUSCAR_DADOS_GERAIS_PUBLICO, this.compraDiretaId)
        },
        construirRota(name) {
            return {
                name,
                params: { id: this.compraDiretaId }
            }
        },
        exibirResultado() {
            return this.compraDireta && this.compraDireta.situacao === 'ENCERRADA'
        },
        setCompraDiretaId(compraDiretaId) {
            this.compraDiretaId = compraDiretaId
        }
    }
}
</script>
<style lang="stylus">
.az-tabs
  margin 20px

  .v-tabs__div
    text-transform none

  .v-tabs__item--active
    font-weight bold
    border-bottom 1px solid white
    border-left 1px solid #ccc
    border-right 1px solid #ccc
    border-top 1px solid #ccc
    border-radius 2px

  .v-tabs__item
    color #777777
    padding 10px 20px

  .v-tabs__slider-wrapper
    display none

  .v-tabs__container
    border-bottom 1px solid #ccc

  .v-text-field__slot
    font-size 14px

  .v-select__selections
    font-size 14px
</style>